// extracted by mini-css-extract-plugin
export default {"-large":"y5SG_XAMGK3_fqG3vR2_","canvasPopupMenu":"adoOwpwF_GHRgvPq823G"};